module.exports = __webpack_public_path__ + "assets/img/description-1-4f42e5fe.png";